export default "__VITE_ASSET__DQbhZ1cB__"